<div class="attentions-upcoming">
  <div class="pasi-card-home">
    <div class="pasi-card-home_header d-flex justify-content-between align-items-baseline flex-wrap">
      <div class="pasi-subtitle">
        {{'SI_UPCOMING_ATTENTIONS' | translate}}
      </div>
      <ng-container *ngIf="hasItemsAppointment && selectedTabId === attentionsTabHomeIds.APPOINTMENT_TAB">
        <div *siSecure="['appointment_management:new']">
          <a class="si-button_link d-flex align-items-center"
             routerLink="/appointment/request">
            <span class="mr-1">{{'SI_APPOINTMENT_REQUEST' | translate}}</span>
            <i class="icosun-calendar"></i>
          </a>
        </div>
      </ng-container>
    </div>
    <div class="pasi-horizontal-tabs d-flex flex-column h-100">
      <div *ngIf="tabs.length > 1" class="pasi-horizontal-tabs_tabs pasi-horizontal-tabs-flex attentions-upcoming_tabs">
        <a *ngFor="let tab of tabs"
           class="pasi-horizontal-tabs_tabs_tab pointer"
           (click)="onSelectTab(tab.id)"
           [class.active]="tab.active">
          <span>{{tab.name | translate}}</span>
        </a>
        <div class="pasi-horizontal-tabs_tabs_empty"></div>
      </div>
      <ng-container [ngSwitch]="selectedTabId">
        <ng-container *ngSwitchCase="attentionsTabHomeIds.APPOINTMENT_TAB">
          <ng-container *ngIf="appointments?.length; else noAppointments">
            <div *ngFor="let appo of appointments; first as isFirst; last as isLast"
                 [class.mb-2]="!isLast">
              <si-appo-appointment-highlight [appoId]="appo.id"
                                             [startDate]="appo.startDate"
                                             [centerName]="appo.centerName"
                                             [centerAddress]="appo.centerAddress"
                                             [professionalName]="appo.professionalName"
                                             [serviceName]="appo.serviceName"
                                             [assistanceTypeCode]="appo.teleconsultation"
                                             [reasonName]="appo.reasonName"
                                             [secondary]="!isFirst"
                                             [arrivalStartDate]="appo.arrivalStartDate"
                                             [arrivalEndDate]="appo.arrivalEndDate"
                                             [cardNumberSEOGA]="appo.cardNumberSEOGA"
                                             [centerLatitude]="appo.centerLatitude"
                                             [centerLongitude]="appo.centerLongitude"
                                             [actions]="appo.actions"
                                             [forceMobile]="true"
                                             (appoAttendanceConfirmed)="onConfirmAttendance()"
              ></si-appo-appointment-highlight>
            </div>
          </ng-container>
          <ng-template #noAppointments>
            <div *ngIf="loadedItemsAppointment" class="d-flex align-items-center justify-content-center my-auto">
              <img class="home-card-illustration" src="/assets/images/calendar.svg" width="153">
              <div class="pl-2 py-3">
                <div class="pasi-no-items-home pb-2">
                  {{'SI_NOT_APPOINTMENT_UPCOMING' | translate}}
                </div>
                <div *siSecure="['appointment_management:new']">
                  <si-go-to-route-button text="SI_APPOINTMENT_REQUEST"
                                         [href]="['appointment/request']"
                                         styleClass="si-button_appo-request w-100"
                  ></si-go-to-route-button>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="attentionsTabHomeIds.INTERVENTION_TAB">
          <ng-container *ngIf="interventions?.length; else noInterventions">
            <div *ngFor="let intervention of interventions; last as isLast" [class.mb-2]="!isLast">
              <si-inter-intervention-item [interventionId]="intervention.id"
                                          [admissionDate]="intervention.admissionDate"
                                          [interventionDate]="intervention.interventionDate"
                                          [serviceName]="intervention.service?.name"
                                          [procedures]="intervention.procedures"
                                          [professionalName]="intervention.professional?.name"
                                          [centerName]="intervention.center?.name"
                                          [forceMobile]="true"
              ></si-inter-intervention-item>
            </div>
          </ng-container>
          <ng-template #noInterventions>
            <div *ngIf="loadedItemsIntervention" class="d-flex align-items-center justify-content-center my-auto">
                <img class="home-card-illustration" src="/assets/images/not_found.svg" width="153">
              <div class="pl-2 py-3">
                <div class="pasi-no-items-home pb-2">
                  {{'SI_NO_CONFIRMED_INTERVENTION' | translate}}
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="(hasItemsAppointment && selectedTabId === attentionsTabHomeIds.APPOINTMENT_TAB)
                           || (hasItemsIntervention && selectedTabId === attentionsTabHomeIds.INTERVENTION_TAB)">
        <div class="pasi-card-home_footer d-flex justify-content-end">
          <a class="pasi-link_view-more d-flex align-items-center"
             [routerLink]="this.selectedTabId === attentionsTabHomeIds.INTERVENTION_TAB ? '/intervention/list/pending' : '/appointment/list/pending'">
            <span class="pasi-link_view-more_text mr-1">{{'SI_VIEW_MORE' | translate}}</span>
            <i class="icosun-arrow_right pasi-link_view-more_icon"></i>
          </a>
        </div>
      </ng-container>
      <ng-container *ngIf="(!loadedItemsAppointment && selectedTabId === attentionsTabHomeIds.APPOINTMENT_TAB)
                           || !loadedItemsIntervention && selectedTabId === attentionsTabHomeIds.INTERVENTION_TAB">
        <div class="pasi-card-loader">
          <p-progressSpinner></p-progressSpinner>
        </div>
      </ng-container>
    </div>
  </div>
</div>
